module.exports = __webpack_public_path__ + "static/media/website.ab7f881c.png";